import ByteVideoUploader from '@byted/uploader';
import { IMMediaUploader } from '../abstract/IMMediaUploader.js';
import 'tslib';
import 'long';
import '../../proto/index.js';
import { ErrorType } from '../../core/consts.js';
import '../../core/metrics/logger.js';
import { BaseError } from '../../core/errors/BaseError.js';
import '../../core/metrics/monitor.js';
import '../../core/network/NetworkItem.js';
import '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../manager/AdapterManager.js';
import '../manager/types.js';
import '../../core/utils/ticker.js';
import '../abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class BrowserMediaUploader extends IMMediaUploader {
    constructor(ctx, options) {
        super(ctx, options);
        this.uploader = new ByteVideoUploader({
            userId: options.userId,
            appId: options.appId,
            useFileExtension: true,
            useServerCurrentTime: true,
            videoConfig: options.videoConfig,
            imageConfig: options.imageConfig,
            region: options.region,
            videoHost: options.videoHost,
            imageHost: options.imageHost
        });
    }
    addFile(file) {
        const option = this.genOption(file);
        this.fileKey = this.uploader.addFile(option);
        return option;
    }
    upload() {
        let resolve;
        let reject;
        this.uploader.start(this.fileKey);
        this.uploader.on('progress', (res) => {
            var _a, _b;
            (_b = (_a = this.options).onUploadProcess) === null || _b === void 0 ? void 0 : _b.call(_a, res);
        });
        this.uploader.on('complete', (res) => {
            resolve(res);
            this.onComplete.next(res, this);
        });
        this.uploader.on('error', (err) => {
            var _a;
            const wrapError = new BaseError({
                ctx: this.ctx,
                msg: 'upload error',
                type: ErrorType.MPUploadError,
                sender: this,
                innerError: (_a = err === null || err === void 0 ? void 0 : err.extra) === null || _a === void 0 ? void 0 : _a.message
            });
            this.onFail.next(wrapError, this);
            reject(wrapError);
        });
        return new Promise((_resolve, _reject) => {
            resolve = _resolve;
            reject = _reject;
        });
    }
}

export { BrowserMediaUploader };
//# sourceMappingURL=BrowserMediaUploader.js.map
